import { SolidButton } from "@components/atoms/base-button";
import { useEffect, useState } from "react";
import classnames from "classnames";
import { Link } from "@shopify/hydrogen";
import ShowcaseApi from "@models/api/showcases-banner";

function useCopicCreateBanner() {
  const [data, setData] = useState(null);

  useEffect(() => {
    async function fetchShowcaseBannerData() {
      try {
        const showcasesBanner = await ShowcaseApi.fetchShowcasesBanner();
        setData(showcasesBanner[0]);
      } catch (error) {
        console.error("Error fetching showcase banner data:", error);
      }
    }
    fetchShowcaseBannerData();
  }, []);

  return {
    models: {
      data,
    },
  };
}

export function CopicCreateBanner() {
  const { models } = useCopicCreateBanner();
  if (!models.data) {
    return null;
  }

  return (
    <>
      {models.data.show && (
        <section
          style={{ backgroundColor: models.data.color }}
          className={classnames("w-full h-[460px]")}
        >
          <div
            className="h-full"
            style={{
              backgroundImage: `url(${models.data.image.url})`,
              backgroundSize: "cover",
              backgroundRepeat: "",
              width: "100%",
            }}
          >
            <div className="flex flex-col max-sm:w-full max-sm:px-5 max-sm:pt-[85px] w-1/3 md:pt-[121px] m  md:ml-5 xl:ml-[121px] 2xl:ml-[347px]">
              <span
                style={{ color: models.data.titleColor }}
                className={classnames(
                  "max-sm:w-full w-[638px] leading-none font-chivo-black-italic text-[45px] mb-5"
                )}
              >
                {models.data.title}
              </span>
              <span
                style={{ color: models.data.descriptionColor }}
                className={classnames(
                  "max-sm:w-full  md:w-[638px] lg:w-[638px] leading-snug  font-chivo-regular text-[22px] mb-5"
                )}
              >
                {models.data.description}
              </span>
              {models.data.propductLink !== "" && (
                <Link to={models.data.propductLink}>
                  <SolidButton
                    style={{ backgroundColor: models.data.preOrderButtonColor }}
                    className={classnames(
                      "max-sm:w-full w-[178px] border-none"
                    )}
                  >
                    {models.data.preOrderButton}
                  </SolidButton>
                </Link>
              )}
            </div>
          </div>
        </section>
      )}
    </>
  );
}
